import { HOST } from '../config';
import { apiDelete, apiGet, apiPost, CancelToken } from '../api';

import { fetchGetAccountInfo } from './auth';
import { makeGetString } from '../helpers';
import axios from 'axios';
import { toast } from 'react-toastify';

export const A = {
  REQUEST_GET_COUNTERAGENTS: 'REQUEST_GET_COUNTERAGENTS',
  RECEIVE_GET_COUNTERAGENTS: 'RECEIVE_GET_COUNTERAGENTS',
  ERROR_GET_COUNTERAGENTS: 'ERROR_GET_COUNTERAGENTS',

  REQUEST_GET_CHECKOUT_SETTINGS: 'REQUEST_GET_CHECKOUT_SETTINGS',
  RECEIVE_GET_CHECKOUT_SETTINGS: 'RECEIVE_GET_CHECKOUT_SETTINGS',
  ERROR_GET_CHECKOUT_SETTINGS: 'ERROR_GET_CHECKOUT_SETTINGS',

  REQUEST_GET_ORGANIZATION_SETTINGS: 'REQUEST_GET_ORGANIZATION_SETTINGS',
  RECEIVE_GET_ORGANIZATION_SETTINGS: 'RECEIVE_GET_ORGANIZATION_SETTINGS',
  ERROR_GET_ORGANIZATION_SETTINGS: 'ERROR_GET_ORGANIZATION_SETTINGS',

  REQUEST_UPDATE_ORGANIZATION_SETTINGS: 'REQUEST_UPDATE_ORGANIZATION_SETTINGS',
  RECEIVE_UPDATE_ORGANIZATION_SETTINGS: 'RECEIVE_UPDATE_ORGANIZATION_SETTINGS',
  ERROR_UPDATE_ORGANIZATION_SETTINGS: 'ERROR_UPDATE_ORGANIZATION_SETTINGS',

  REQUEST_GET_DOMAIN_ALIAS_SETTINGS: 'REQUEST_GET_DOMAIN_ALIAS_SETTINGS',
  RECEIVE_GET_DOMAIN_ALIAS_SETTINGS: 'RECEIVE_GET_DOMAIN_ALIAS_SETTINGS',
  ERROR_GET_DOMAIN_ALIAS_SETTINGS: 'ERROR_GET_DOMAIN_ALIAS_SETTINGS',

  REQUEST_UPDATE_DOMAIN_ALIAS_SETTINGS: 'REQUEST_UPDATE_DOMAIN_ALIAS_SETTINGS',
  RECEIVE_UPDATE_DOMAIN_ALIAS_SETTINGS: 'RECEIVE_UPDATE_DOMAIN_ALIAS_SETTINGS',
  ERROR_UPDATE_DOMAIN_ALIAS_SETTINGS: 'ERROR_UPDATE_DOMAIN_ALIAS_SETTINGS',

  REQUEST_GET_PAYMENT_METHODS: 'REQUEST_GET_PAYMENT_METHODS',
  RECEIVE_GET_PAYMENT_METHODS: 'RECEIVE_GET_PAYMENT_METHODS',
  ERROR_GET_PAYMENT_METHODS: 'ERROR_GET_PAYMENT_METHODS',

  REQUEST_UPDATE_CHECKOUT_SETTINGS: 'REQUEST_UPDATE_CHECKOUT_SETTINGS',
  RECEIVE_UPDATE_CHECKOUT_SETTINGS: 'RECEIVE_UPDATE_CHECKOUT_SETTINGS',
  ERROR_UPDATE_CHECKOUT_SETTINGS: 'ERROR_UPDATE_CHECKOUT_SETTINGS',

  REQUEST_UPDATE_DELIVERY_INFO_LIST_SETTINGS: 'REQUEST_UPDATE_DELIVERY_INFO_LIST_SETTINGS',
  RECEIVE_UPDATE_DELIVERY_INFO_LIST_SETTINGS: 'RECEIVE_UPDATE_DELIVERY_INFO_LIST_SETTINGS',
  ERROR_UPDATE_DELIVERY_INFO_LIST_SETTINGS: 'ERROR_UPDATE_DELIVERY_INFO_LIST_SETTINGS',

  REQUEST_UPDATE_PAYMENT_METHOD_SETTINGS: 'REQUEST_UPDATE_PAYMENT_METHOD_SETTINGS',
  RECEIVE_UPDATE_PAYMENT_METHOD_SETTINGS: 'RECEIVE_UPDATE_PAYMENT_METHOD_SETTINGS',
  ERROR_UPDATE_PAYMENT_METHOD_SETTINGS: 'ERROR_UPDATE_PAYMENT_METHOD_SETTINGS',

  REQUEST_UPDATE_ACQUARING_SETTINGS: 'REQUEST_UPDATE_ACQUARING_SETTINGS',
  RECEIVE_UPDATE_ACQUARING_SETTINGS: 'RECEIVE_UPDATE_ACQUARING_SETTINGS',
  ERROR_UPDATE_ACQUARING_SETTINGS: 'ERROR_UPDATE_ACQUARING_SETTINGS',

  REQUEST_DELETE_PAYMENT_METHOD_SETTINGS: 'REQUEST_DELETE_PAYMENT_METHOD_SETTINGS',
  RECEIVE_DELETE_PAYMENT_METHOD_SETTINGS: 'RECEIVE_DELETE_PAYMENT_METHOD_SETTINGS',
  ERROR_DELETE_PAYMENT_METHOD_SETTINGS: 'ERROR_DELETE_PAYMENT_METHOD_SETTINGS',

  REQUEST_GET_EMAIL_EDITABLE_TEMPLATE: 'REQUEST_EMAIL_EDITABLE_TEMPLATE',
  RECEIVE_GET_EMAIL_EDITABLE_TEMPLATE: 'RECEIVE_GET_EMAIL_EDITABLE_TEMPLATE',
  ERROR_GET_EMAIL_EDITABLE_TEMPLATE: 'ERROR_GET_EMAIL_EDITABLE_TEMPLATE',

  REQUEST_UPDATE_EMAIL_EDITABLE_TEMPLATE: 'REQUEST_UPDATE_EMAIL_EDITABLE_TEMPLATE',
  RECEIVE_UPDATE_EMAIL_EDITABLE_TEMPLATE: 'RECEIVE_UPDATE_EMAIL_EDITABLE_TEMPLATE',
  ERROR_UPDATE_EMAIL_EDITABLE_TEMPLATE: 'ERROR_UPDATE_EMAIL_EDITABLE_TEMPLATE',

  REQUEST_GET_EMAIL_SERVER_SETTINGS: 'REQUEST_EMAIL_SERVER_SETTINGS',
  RECEIVE_GET_EMAIL_SERVER_SETTINGS: 'RECEIVE_GET_EMAIL_SERVER_SETTINGS',
  ERROR_GET_EMAIL_SERVER_SETTINGS: 'ERROR_GET_EMAIL_SERVER_SETTINGS',

  REQUEST_UPDATE_EMAIL_SERVER_SETTINGS: 'REQUEST_UPDATE_EMAIL_SERVER_SETTINGS',
  RECEIVE_UPDATE_EMAIL_SERVER_SETTINGS: 'RECEIVE_UPDATE_EMAIL_SERVER_SETTINGS',
  ERROR_UPDATE_EMAIL_SERVER_SETTINGS: 'ERROR_UPDATE_EMAIL_SERVER_SETTINGS',

  REQUEST_GET_COUNTRIES_LIST: 'REQUEST_GET_COUNTRIES_LIST',
  RECEIVE_GET_COUNTRIES_LIST: 'RECEIVE_GET_COUNTRIES_LIST',
  ERROR_GET_COUNTRIES_LIST: 'ERROR_GET_COUNTRIES_LIST',

  REQUEST_UPDATE_COUNTREAGENTS: 'REQUEST_UPDATE_COUNTREAGENTS',
  RECEIVE_UPDATE_COUNTREAGENTS: 'RECEIVE_UPDATE_COUNTREAGENTS',
  ERROR_UPDATE_COUNTREAGENTS: 'ERROR_UPDATE_COUNTREAGENTS',

  REQUEST_DELETE_COUNTREAGENT: 'REQUEST_DELETE_COUNTREAGENT',
  RECEIVE_DELETE_COUNTREAGENT: 'RECEIVE_DELETE_COUNTREAGENT',
  ERROR_DELETE_COUNTREAGENT: 'ERROR_DELETE_COUNTREAGENT',

  REQUEST_GET_PROMOCODES: 'REQUEST_GET_PROMOCODES',
  RECEIVE_GET_PROMOCODES: 'RECEIVE_GET_PROMOCODES',
  ERROR_GET_PROMOCODES: 'ERROR_GET_PROMOCODES',

  REQUEST_SAVE_PROMOCODE: 'REQUEST_SAVE_PROMOCODE',
  RECEIVE_SAVE_PROMOCODE: 'RECEIVE_SAVE_PROMOCODE',
  ERROR_SAVE_PROMOCODE: 'ERROR_GET_SAVE_PROMOCODE',

  REQUEST_DELETE_PROMOCODE: 'REQUEST_DELETE_PROMOCODE',
  RECEIVE_DELETE_PROMOCODE: 'RECEIVE_DELETE_PROMOCODE',
  ERROR_DELETE_PROMOCODE: 'ERROR_GET_DELETE_PROMOCODE',

  REQUEST_GET_FEED_SETTINGS: 'REQUEST_GET_FEED_SETTINGS',
  RECEIVE_GET_FEED_SETTINGS: 'RECEIVE_GET_FEED_SETTINGS',
  ERROR_GET_FEED_SETTINGS: 'ERROR_GET_FEED_SETTINGS',

  REQUEST_DELETE_FEED_SETTINGS: 'REQUEST_DELETE_FEED_SETTINGS',
  RECEIVE_DELETE_FEED_SETTINGS: 'RECEIVE_DELETE_FEED_SETTINGS',
  ERROR_DELETE_FEED_SETTINGS: 'ERROR_DELETE_FEED_SETTINGS',

  REQUEST_UPDATE_FEED_SETTINGS: 'REQUEST_UPDATE_FEED_SETTINGS',
  RECEIVE_UPDATE_FEED_SETTINGS: 'RECEIVE_UPDATE_FEED_SETTINGS',
  ERROR_UPDATE_FEED_SETTINGS: 'ERROR_UPDATE_FEED_SETTINGS',

  REQUEST_REFRESH_FEED: 'REQUEST_REFRESH_FEED',
  RECEIVE_REFRESH_FEED: 'RECEIVE_REFRESH_FEED',
  ERROR_REFRESH_FEED: 'ERROR_REFRESH_FEED',

  REQUEST_GET_PRICE_SETTINGS: 'REQUEST_GET_PRICE_SETTINGS',
  RECEIVE_GET_PRICE_SETTINGS: 'RECEIVE_GET_PRICE_SETTINGS',
  ERROR_GET_PRICE_SETTINGS: 'ERROR_GET_PRICE_SETTINGS',

  REQUEST_UPDATE_PRICE_SETTINGS: 'REQUEST_UPDATE_PRICE_SETTINGS',
  RECEIVE_UPDATE_PRICE_SETTINGS: 'RECEIVE_UPDATE_PRICE_SETTINGS',
  ERROR_UPDATE_PRICE_SETTINGS: 'ERROR_UPDATE_PRICE_SETTINGS',

  REQUEST_GET_USERS: 'REQUEST_GET_USERS',
  RECEIVE_GET_USERS: 'RECEIVE_GET_USERS',
  ERROR_GET_USERS: 'ERROR_GET_USERS',

  REQUEST_UPDATE_USER: 'REQUEST_UPDATE_USER',
  RECEIVE_UPDATE_USER: 'RECEIVE_UPDATE_USER',
  ERROR_UPDATE_USER: 'ERROR_UPDATE_USER',

  REQUEST_DELETE_USER: 'REQUEST_DELETE_USER',
  RECEIVE_DELETE_USER: 'RECEIVE_DELETE_USER',
  ERROR_DELETE_USER: 'ERROR_DELETE_USER',

  REQUEST_GET_USER_ROLES: 'REQUEST_GET_USER_ROLES',
  RECEIVE_GET_USER_ROLES: 'RECEIVE_GET_USER_ROLES',
  ERROR_GET_USER_ROLES: 'ERROR_GET_USER_ROLES',

  REQUEST_UPDATE_USER_ROLE: 'REQUEST_UPDATE_USER_ROLE',
  RECEIVE_UPDATE_USER_ROLE: 'RECEIVE_UPDATE_USER_ROLE',
  ERROR_UPDATE_USER_ROLE: 'ERROR_UPDATE_USER_ROLE',

  REQUEST_DELETE_USER_ROLE: 'REQUEST_DELETE_USER_ROLE',
  RECEIVE_DELETE_USER_ROLE: 'RECEIVE_DELETE_USER_ROLE',
  ERROR_DELETE_USER_ROLE: 'ERROR_DELETE_USER_ROLE',

  REQUEST_GET_PAYMENT_SETTINGS: 'REQUEST_GET_PAYMENT_SETTINGS',
  RECEIVE_GET_PAYMENT_SETTINGS: 'RECEIVE_GET_PAYMENT_SETTINGS',
  ERROR_GET_PAYMENT_SETTINGS: 'ERROR_GET_PAYMENT_SETTINGS',

  REQUEST_GET_NOTIFICATIONS: 'REQUEST_GET_NOTIFICATIONS',
  RECEIVE_GET_NOTIFICATIONS: 'RECEIVE_GET_NOTIFICATIONS',
  ERROR_GET_NOTIFICATIONS: 'ERROR_GET_NOTIFICATIONS',

  REQUEST_GET_NOTIFICATION_TYPES: 'REQUEST_GET_NOTIFICATION_TYPES',
  RECEIVE_GET_NOTIFICATION_TYPES: 'RECEIVE_GET_NOTIFICATION_TYPES',
  ERROR_GET_NOTIFICATION_TYPES: 'ERROR_GET_NOTIFICATION_TYPES',

  REQUEST_UPDATE_NOTIFICATION: 'REQUEST_UPDATE_NOTIFICATION',
  RECEIVE_UPDATE_NOTIFICATION: 'RECEIVE_UPDATE_NOTIFICATION',
  ERROR_UPDATE_NOTIFICATION: 'ERROR_UPDATE_NOTIFICATION',

  REQUEST_DELETE_NOTIFICATION: 'REQUEST_DELETE_NOTIFICATION',
  RECEIVE_DELETE_NOTIFICATION: 'RECEIVE_DELETE_NOTIFICATION',
  ERROR_DELETE_NOTIFICATION: 'ERROR_DELETE_NOTIFICATION',

  REQUEST_UPDATE_AD_ATTACHMENTS: 'REQUEST_UPDATE_AD_ATTACHMENTS',
  RECEIVE_UPDATE_AD_ATTACHMENTS: 'RECEIVE_UPDATE_AD_ATTACHMENTS',
  ERROR_UPDATE_AD_ATTACHMENTS: 'ERROR_UPDATE_AD_ATTACHMENTS',

  REQUEST_GET_AD_ATTACHMENTS: 'REQUEST_GET_AD_ATTACHMENTS',
  RECEIVE_GET_AD_ATTACHMENTS: 'RECEIVE_GET_AD_ATTACHMENTS',
  ERROR_GET_AD_ATTACHMENTS: 'ERROR_GET_AD_ATTACHMENTS',

  REQUEST_DELETE_AD_ATTACHMENTS: 'REQUEST_DELETE_AD_ATTACHMENTS',
  RECEIVE_DELETE_AD_ATTACHMENTS: 'RECEIVE_DELETE_AD_ATTACHMENTS',
  ERROR_DELETE_AD_ATTACHMENTS: 'ERROR_DELETE_AD_ATTACHMENTS',

  REQUEST_GET_PROVIDERS: 'REQUEST_GET_PROVIDERS',
  RECEIVE_GET_PROVIDERS: 'RECEIVE_GET_PROVIDERS',
  ERROR_GET_PROVIDERS: 'ERROR_GET_PROVIDERS',

  REQUEST_POST_PROVIDER: 'REQUEST_POST_PROVIDER',
  RECEIVE_POST_PROVIDER: 'RECEIVE_POST_PROVIDER',
  ERROR_POST_PROVIDER: 'ERROR_POST_PROVIDER',

  REQUEST_GET_ESHOPS_INFO: 'REQUEST_GET_ESHOPS_INFO',
  RECEIVE_GET_ESHOPS_INFO: 'RECEIVE_GET_ESHOPS_INFO',
  ERROR_GET_ESHOPS_INFO: 'ERROR_GET_ESHOPS_INFO',
  ERROR_UPDATE_ESHOP_INFO: 'ERROR_UPDATE_ESHOP_INFO',
};

export const fetchGetCounteragents = (data) => {
  let url = `${HOST}/api/lite/settings/counteragents${makeGetString(data)}`;
  return (dispatch, getState) => {
    dispatch(requestGetCounteragents());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetCounteragents(res.counteragents));
            resolve({ counteragents: res.counteragents, recordsTotal: res.recordsTotal });
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCounteragents(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCounteragents(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCounteragents = () => {
  return {
    type: A.REQUEST_GET_COUNTERAGENTS,
  };
};

const receiveGetCounteragents = (data) => {
  return {
    type: A.RECEIVE_GET_COUNTERAGENTS,
    data,
  };
};

const errorGetCounteragents = (err) => {
  return {
    type: A.ERROR_GET_COUNTERAGENTS,
    err,
  };
};

export const fetchUpdateCounteragents = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateCounteragents());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/counteragents`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateCounteragents());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateCounteragents(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateCounteragents(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateCounteragents = () => {
  return {
    type: A.REQUEST_UPDATE_COUNTREAGENTS,
  };
};

const receiveUpdateCounteragents = (data) => {
  return {
    type: A.RECEIVE_UPDATE_COUNTREAGENTS,
    data,
  };
};

const errorUpdateCounteragents = (err) => {
  return {
    type: A.ERROR_UPDATE_COUNTREAGENTS,
    err,
  };
};

export const fetchGetCheckoutSettings = () => {
  return (dispatch, getState) => {
    dispatch(requestGetCheckoutSettings());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/settings/checkout`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetCheckoutSettings(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCheckoutSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCheckoutSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCheckoutSettings = () => {
  return {
    type: A.REQUEST_GET_CHECKOUT_SETTINGS,
  };
};

const receiveGetCheckoutSettings = (data) => {
  return {
    type: A.RECEIVE_GET_CHECKOUT_SETTINGS,
    data,
  };
};

const errorGetCheckoutSettings = (err) => {
  return {
    type: A.ERROR_GET_CHECKOUT_SETTINGS,
    err,
  };
};

export const fetchGetOrganizationSettings = () => {
  return (dispatch, getState) => {
    dispatch(requestGetOrganizationSettings());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/settings/organization`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetOrganizationSettings(res.organization));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetOrganizationSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetOrganizationSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetOrganizationSettings = () => {
  return {
    type: A.REQUEST_GET_ORGANIZATION_SETTINGS,
  };
};

const receiveGetOrganizationSettings = (data) => {
  return {
    type: A.RECEIVE_GET_ORGANIZATION_SETTINGS,
    data,
  };
};

const errorGetOrganizationSettings = (err) => {
  return {
    type: A.ERROR_GET_ORGANIZATION_SETTINGS,
    err,
  };
};

export const fetchUpdateOrganizationSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateOrganizationSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/organization`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrganizationSettings(res.organization));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrganizationSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrganizationSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateOrganizationSettings = () => {
  return {
    type: A.REQUEST_UPDATE_ORGANIZATION_SETTINGS,
  };
};

const receiveUpdateOrganizationSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ORGANIZATION_SETTINGS,
    data,
  };
};

const errorUpdateOrganizationSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_ORGANIZATION_SETTINGS,
    err,
  };
};

export const fetchGetDomainAliasSettings = () => {
  return (dispatch, getState) => {
    dispatch(requestGetDomainAliasSettings());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/settings/domainAlias`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetDomainAliasSettings(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetDomainAliasSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetDomainAliasSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetDomainAliasSettings = () => {
  return {
    type: A.REQUEST_GET_DOMAIN_ALIAS_SETTINGS,
  };
};

const receiveGetDomainAliasSettings = (data) => {
  return {
    type: A.RECEIVE_GET_DOMAIN_ALIAS_SETTINGS,
    data,
  };
};

const errorGetDomainAliasSettings = (err) => {
  return {
    type: A.ERROR_GET_DOMAIN_ALIAS_SETTINGS,
    err,
  };
};

export const fetchUpdateDomainAliasSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateDomainAliasSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/domainAlias`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateDomainAliasSettings());
            dispatch(fetchGetAccountInfo());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateDomainAliasSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateDomainAliasSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateDomainAliasSettings = () => {
  return {
    type: A.REQUEST_UPDATE_DOMAIN_ALIAS_SETTINGS,
  };
};

const receiveUpdateDomainAliasSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_DOMAIN_ALIAS_SETTINGS,
    data,
  };
};

const errorUpdateDomainAliasSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_DOMAIN_ALIAS_SETTINGS,
    err,
  };
};

export const fetchGetPaymentMethods = () => {
  let url = `${HOST}/api/lite/settings/payment-methods`;
  return (dispatch, getState) => {
    dispatch(requestGetPaymentMethods());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPaymentMethods(res.paymentMethods));
            resolve(res.paymentMethods);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPaymentMethods(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPaymentMethods(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPaymentMethods = () => {
  return {
    type: A.REQUEST_GET_PAYMENT_METHODS,
  };
};

const receiveGetPaymentMethods = (data) => {
  return {
    type: A.RECEIVE_GET_PAYMENT_METHODS,
    data,
  };
};

const errorGetPaymentMethods = (err) => {
  return {
    type: A.ERROR_GET_PAYMENT_METHODS,
    err,
  };
};

export const fetchUpdateCheckoutSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateCheckoutSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/checkout`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateCheckoutSettings());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateCheckoutSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateCheckoutSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateCheckoutSettings = () => {
  return {
    type: A.REQUEST_UPDATE_CHECKOUT_SETTINGS,
  };
};

const receiveUpdateCheckoutSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_CHECKOUT_SETTINGS,
    data,
  };
};

const errorUpdateCheckoutSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_CHECKOUT_SETTINGS,
    err,
  };
};

export const fetchUpdateDeliveryInfoListSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateDeliveryInfoListSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/delivery-info-list`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateDeliveryInfoListSettings());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateDeliveryInfoListSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateDeliveryInfoListSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateDeliveryInfoListSettings = () => {
  return {
    type: A.REQUEST_UPDATE_DELIVERY_INFO_LIST_SETTINGS,
  };
};

const receiveUpdateDeliveryInfoListSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_DELIVERY_INFO_LIST_SETTINGS,
    data,
  };
};

const errorUpdateDeliveryInfoListSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_DELIVERY_INFO_LIST_SETTINGS,
    err,
  };
};

export const fetchUpdatePaymentMethodSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdatePaymentMethodSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/payment-methods`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdatePaymentMethodSettings());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdatePaymentMethodSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdatePaymentMethodSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdatePaymentMethodSettings = () => {
  return {
    type: A.REQUEST_UPDATE_PAYMENT_METHOD_SETTINGS,
  };
};

const receiveUpdatePaymentMethodSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_PAYMENT_METHOD_SETTINGS,
    data,
  };
};

const errorUpdatePaymentMethodSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_PAYMENT_METHOD_SETTINGS,
    err,
  };
};

export const fetchUpdateAcquaringSettings = (data, apiPaymentProvider) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAcquaringSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/payment/${apiPaymentProvider}`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAcquaringSettings());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAcquaringSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAcquaringSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateAcquaringSettings = () => {
  return {
    type: A.REQUEST_UPDATE_ACQUARING_SETTINGS,
  };
};

const receiveUpdateAcquaringSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ACQUARING_SETTINGS,
    data,
  };
};

const errorUpdateAcquaringSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_ACQUARING_SETTINGS,
    err,
  };
};

export const fetchDeletePaymentMethodSettings = (code) => {
  return (dispatch, getState) => {
    dispatch(requestDeletePaymentMethodSettings());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/settings/payment-methods?code=' + code,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeletePaymentMethodSettings(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeletePaymentMethodSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeletePaymentMethodSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeletePaymentMethodSettings = () => {
  return {
    type: A.REQUEST_DELETE_PAYMENT_METHOD_SETTINGS,
  };
};

const receiveDeletePaymentMethodSettings = (data) => {
  return {
    type: A.RECEIVE_DELETE_PAYMENT_METHOD_SETTINGS,
    data,
  };
};

const errorDeletePaymentMethodSettings = (err) => {
  return {
    type: A.ERROR_DELETE_PAYMENT_METHOD_SETTINGS,
    err,
  };
};

export const fetchGetEmailTemplate = () => {
  return (dispatch, getState) => {
    return axios
      .get('/message-templates/LiteOrderEmail.ftl', {
        responseType: 'text/html',
      })
      .then((res) => res.data);
  };
};

export const fetchGetEmailEditableTemplate = () => {
  let url = `${HOST}/api/lite/settings/email/order`;
  return (dispatch, getState) => {
    dispatch(requestGetEmailEditableTemplate());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetEmailEditableTemplate(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetEmailEditableTemplate(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetEmailEditableTemplate(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEmailEditableTemplate = () => {
  return {
    type: A.REQUEST_GET_EMAIL_EDITABLE_TEMPLATE,
  };
};

const receiveGetEmailEditableTemplate = (data) => {
  return {
    type: A.RECEIVE_GET_EMAIL_EDITABLE_TEMPLATE,
    data,
  };
};

const errorGetEmailEditableTemplate = (err) => {
  return {
    type: A.ERROR_GET_EMAIL_EDITABLE_TEMPLATE,
    err,
  };
};

export const fetchUpdateEmailEditableTemplate = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateEmailEditableTemplate());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/email/order`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateEmailEditableTemplate());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateEmailEditableTemplate(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateEmailEditableTemplate(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateEmailEditableTemplate = () => {
  return {
    type: A.REQUEST_UPDATE_EMAIL_EDITABLE_TEMPLATE,
  };
};

const receiveUpdateEmailEditableTemplate = (data) => {
  return {
    type: A.RECEIVE_UPDATE_EMAIL_EDITABLE_TEMPLATE,
    data,
  };
};

const errorUpdateEmailEditableTemplate = (err) => {
  return {
    type: A.ERROR_UPDATE_EMAIL_EDITABLE_TEMPLATE,
    err,
  };
};

export const fetchGetEmailServerSettings = () => {
  let url = `${HOST}/api/lite/settings/email/personal`;
  return (dispatch, getState) => {
    dispatch(requestGetEmailServerSettings());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          /*В этом ответе сервер не возвращает success!
										if(res.success){*/
          dispatch(receiveGetEmailServerSettings(res));
          resolve(res);
          /*} else {
												const err = {data:{errors:res.errors}};
												dispatch(errorGetEmailServerSettings(err));
												reject(err);
										}*/
        },
        error: (err) => {
          dispatch(errorGetEmailServerSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEmailServerSettings = () => {
  return {
    type: A.REQUEST_GET_EMAIL_SERVER_SETTINGS,
  };
};

const receiveGetEmailServerSettings = (data) => {
  return {
    type: A.RECEIVE_GET_EMAIL_SERVER_SETTINGS,
    data,
  };
};

const errorGetEmailServerSettings = (err) => {
  return {
    type: A.ERROR_GET_EMAIL_SERVER_SETTINGS,
    err,
  };
};

export const fetchUpdateEmailServerSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateEmailServerSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/email/personal`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateEmailServerSettings());
            resolve(res);
          } else {
            //При разных ошибках API выдает результат с разными именами полей
            const errors = (res.errorList || res.errors).map((err) => ({
              ...err,
              message: err.message || err.errorMessage,
            }));
            const errObject = { data: { errors } };
            dispatch(errorUpdateEmailEditableTemplate(errObject));
            reject(errObject);
          }
        },
        error: (err) => {
          dispatch(errorUpdateEmailServerSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateEmailServerSettings = () => {
  return {
    type: A.REQUEST_UPDATE_EMAIL_SERVER_SETTINGS,
  };
};

const receiveUpdateEmailServerSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_EMAIL_SERVER_SETTINGS,
    data,
  };
};

const errorUpdateEmailServerSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_EMAIL_SERVER_SETTINGS,
    err,
  };
};

export const fetchGetCountriesList = () => {
  return (dispatch, getState) => {
    dispatch(requestGetCountriesList());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/settings/countries`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetCountriesList(res.countries));
            resolve(res.countries);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetCountriesList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetCountriesList(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetCountriesList = () => {
  return {
    type: A.REQUEST_GET_COUNTRIES_LIST,
  };
};

const receiveGetCountriesList = (data) => {
  return {
    type: A.RECEIVE_GET_COUNTRIES_LIST,
    data,
  };
};

const errorGetCountriesList = (err) => {
  return {
    type: A.ERROR_GET_COUNTRIES_LIST,
    err,
  };
};

export const fetchDeleteCounteragent = (id) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteCounteragent());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/settings/counteragents?id=' + id,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteCounteragent(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteCounteragent(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteCounteragent(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteCounteragent = () => {
  return {
    type: A.REQUEST_DELETE_COUNTREAGENT,
  };
};

const receiveDeleteCounteragent = (data) => {
  return {
    type: A.RECEIVE_DELETE_COUNTREAGENT,
    data,
  };
};

const errorDeleteCounteragent = (err) => {
  return {
    type: A.ERROR_DELETE_COUNTREAGENT,
    err,
  };
};

let fetchGetPromocodesCancel = () => null;

export const fetchGetPromocodes = ({ size, page, currentCode, codeSearch }) => {
  let url = `${HOST}/api/lite/settings/promocode?size=${size}`;
  if (currentCode) {
    url = `${HOST}/api/lite/settings/promocode?code=${currentCode}`;
  }
  if (codeSearch) {
    url += `&codeSearch=${codeSearch}`;
  }
  if (page) {
    url += `&page=${page}`;
  }
  return (dispatch, getState) => {
    fetchGetPromocodesCancel();
    dispatch(requestGetPromocodes());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        cancelToken: new CancelToken(function (cancel) {
          fetchGetPromocodesCancel = cancel;
        }),
        callback: (res) => {
          if (res.success) {
            let result = res;
            if (typeof search !== 'undefined') {
              result = [res];
            }
            dispatch(receiveGetPromocodes(result));
            resolve(result);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPromocodes(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPromocodes(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPromocodes = () => {
  return {
    type: A.REQUEST_GET_PROMOCODES,
  };
};

const receiveGetPromocodes = (data) => {
  return {
    type: A.RECEIVE_GET_PROMOCODES,
    data,
  };
};

const errorGetPromocodes = (err) => {
  return {
    type: A.ERROR_GET_PROMOCODES,
    err,
  };
};

export const fetchSavePromocode = (data) => {
  return (dispatch, getState) => {
    dispatch(requestSavePromocode());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/settings/promocode',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveSavePromocode(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorSavePromocode(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorSavePromocode(err));
          reject(err);
        },
      });
    });
  };
};

const requestSavePromocode = () => {
  return {
    type: A.REQUEST_SAVE_PROMOCODE,
  };
};

const receiveSavePromocode = (data) => {
  return {
    type: A.RECEIVE_SAVE_PROMOCODE,
    data,
  };
};

const errorSavePromocode = (err) => {
  return {
    type: A.ERROR_SAVE_PROMOCODE,
    err,
  };
};

export const fetchDeletePromocode = (code) => {
  return (dispatch, getState) => {
    dispatch(requestDeletePromocode());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/settings/promocode?code=' + code,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeletePromocode(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeletePromocode(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeletePromocode(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeletePromocode = () => {
  return {
    type: A.REQUEST_DELETE_PROMOCODE,
  };
};

const receiveDeletePromocode = (data) => {
  return {
    type: A.RECEIVE_DELETE_PROMOCODE,
    data,
  };
};

const errorDeletePromocode = (err) => {
  return {
    type: A.ERROR_DELETE_PROMOCODE,
    err,
  };
};

export const fetchGetFeedSettings = () => {
  let url = `${HOST}/api/lite/feed/settings`;
  return (dispatch, getState) => {
    dispatch(requestGetFeedSettings());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetFeedSettings(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetFeedSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetFeedSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetFeedSettings = () => {
  return {
    type: A.REQUEST_GET_FEED_SETTINGS,
  };
};

const receiveGetFeedSettings = (data) => {
  return {
    type: A.RECEIVE_GET_FEED_SETTINGS,
    data,
  };
};

const errorGetFeedSettings = (err) => {
  return {
    type: A.ERROR_GET_FEED_SETTINGS,
    err,
  };
};

export const fetchDeleteFeedSettings = (id) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteFeedSettings());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/feed/settings?id=' + id,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteFeedSettings(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteFeedSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteFeedSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteFeedSettings = () => {
  return {
    type: A.REQUEST_DELETE_FEED_SETTINGS,
  };
};

const receiveDeleteFeedSettings = (data) => {
  return {
    type: A.RECEIVE_DELETE_FEED_SETTINGS,
    data,
  };
};

const errorDeleteFeedSettings = (err) => {
  return {
    type: A.ERROR_DELETE_FEED_SETTINGS,
    err,
  };
};

export const fetchUpdateFeedSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateFeedSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/feed/settings`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateFeedSettings());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateFeedSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateFeedSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateFeedSettings = () => {
  return {
    type: A.REQUEST_UPDATE_FEED_SETTINGS,
  };
};

const receiveUpdateFeedSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_FEED_SETTINGS,
    data,
  };
};

const errorUpdateFeedSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_FEED_SETTINGS,
    err,
  };
};

export const fetchRefreshFeed = (id) => {
  return (dispatch, getState) => {
    dispatch(requestRefreshFeed());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/feed/refresh?id=' + id,
        tokens: getState().auth.tokenData,
        withoutCommonHeaders: true,

        callback: (res) => {
          if (res.success) {
            dispatch(receiveRefreshFeed(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorRefreshFeed(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorRefreshFeed(err));
          reject(err);
        },
      });
    });
  };
};

const requestRefreshFeed = () => {
  return {
    type: A.REQUEST_REFRESH_FEED,
  };
};

const receiveRefreshFeed = (data) => {
  return {
    type: A.RECEIVE_REFRESH_FEED,
    data,
  };
};

const errorRefreshFeed = (err) => {
  return {
    type: A.ERROR_REFRESH_FEED,
    err,
  };
};

export const fetchGetPriceSettings = () => {
  let url = `${HOST}/api/lite/settings/price-types`;
  return (dispatch, getState) => {
    dispatch(requestGetPriceSettings());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPriceSettings(res.priceTypes));
            resolve(res.priceTypes);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPriceSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPriceSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPriceSettings = () => {
  return {
    type: A.REQUEST_GET_PRICE_SETTINGS,
  };
};

const receiveGetPriceSettings = (data) => {
  return {
    type: A.RECEIVE_GET_PRICE_SETTINGS,
    data,
  };
};

const errorGetPriceSettings = (err) => {
  return {
    type: A.ERROR_GET_PRICE_SETTINGS,
    err,
  };
};

export const fetchUpdatePriceSettings = (data) => {
  let url = `${HOST}/api/lite/settings/price-types`;
  return (dispatch, getState) => {
    dispatch(requestUpdatePriceSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdatePriceSettings(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdatePriceSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdatePriceSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdatePriceSettings = () => {
  return {
    type: A.REQUEST_UPDATE_PRICE_SETTINGS,
  };
};

const receiveUpdatePriceSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_PRICE_SETTINGS,
    data,
  };
};

const errorUpdatePriceSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_PRICE_SETTINGS,
    err,
  };
};

export const fetchGetUsers = () => {
  let url = `${HOST}/api/lite/settings/users`;
  return (dispatch, getState) => {
    dispatch(requestGetUsers());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetUsers(res.users));
            resolve(res.users);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetUsers(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetUsers(err));
          reject(err);
        },
      });
    });
  };
};

export const fetchGetUsersSearch = ({ size, codeSearch }) => {
  let url = `${HOST}/api/lite/settings/users?size=${size}`;
  if (codeSearch) {
    url += `&query=${codeSearch}`;
  }
  return (dispatch, getState) => {
    dispatch(requestGetUsers());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            let result = res;
            if (typeof search !== 'undefined') {
              result = [res];
            }

            dispatch(receiveGetUsers(result));
            resolve(result);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetUsers(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetUsers(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetUsers = () => {
  return {
    type: A.REQUEST_GET_USERS,
  };
};

const receiveGetUsers = (data) => {
  return {
    type: A.RECEIVE_GET_USERS,
  };
};

const errorGetUsers = (err) => {
  return {
    type: A.ERROR_GET_USERS,
    err,
  };
};

export const fetchUpdateUser = (data) => {
  let url = `${HOST}/api/lite/settings/users`;
  return (dispatch, getState) => {
    dispatch(requestUpdateUser());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateUser());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateUser(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateUser(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateUser = () => {
  return {
    type: A.REQUEST_UPDATE_USER,
  };
};

const receiveUpdateUser = (data) => {
  return {
    type: A.RECEIVE_UPDATE_USER,
    data,
  };
};

const errorUpdateUser = (err) => {
  return {
    type: A.ERROR_UPDATE_USER,
    err,
  };
};

export const fetchDeleteUser = (login) => {
  let url = `${HOST}/api/lite/settings/users?login=${login}`;
  return (dispatch, getState) => {
    dispatch(requestDeleteUser());
    return new Promise((resolve, reject) => {
      apiDelete({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteUser());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteUser(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteUser(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteUser = () => {
  return {
    type: A.REQUEST_DELETE_USER,
  };
};

const receiveDeleteUser = (data) => {
  return {
    type: A.RECEIVE_DELETE_USER,
    data,
  };
};

const errorDeleteUser = (err) => {
  return {
    type: A.ERROR_DELETE_USER,
    err,
  };
};

export const fetchGetUserRoles = () => {
  let url = `${HOST}/api/lite/settings/users/roles`;
  return (dispatch, getState) => {
    dispatch(requestGetUserRoles());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetUserRoles(res.roles));
            resolve(res.roles);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetUserRoles(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetUserRoles(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetUserRoles = () => {
  return {
    type: A.REQUEST_GET_USER_ROLES,
  };
};

const receiveGetUserRoles = (data) => {
  return {
    type: A.RECEIVE_GET_USER_ROLES,
    data,
  };
};

const errorGetUserRoles = (err) => {
  return {
    type: A.ERROR_GET_USER_ROLES,
    err,
  };
};

export const fetchUpdateUserRole = (data) => {
  let url = `${HOST}/api/lite/settings/users/roles`;
  return (dispatch, getState) => {
    dispatch(requestUpdateUserRole());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateUserRole());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateUserRole(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateUserRole(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateUserRole = () => {
  return {
    type: A.REQUEST_UPDATE_USER_ROLE,
  };
};

const receiveUpdateUserRole = (data) => {
  return {
    type: A.RECEIVE_UPDATE_USER_ROLE,
    data,
  };
};

const errorUpdateUserRole = (err) => {
  return {
    type: A.ERROR_UPDATE_USER_ROLE,
    err,
  };
};

export const fetchDeleteUserRole = (roleId) => {
  let url = `${HOST}/api/lite/settings/users/roles?id=${roleId}`;
  return (dispatch, getState) => {
    dispatch(requestDeleteUserRole());
    return new Promise((resolve, reject) => {
      apiDelete({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteUserRole());
            resolve();
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteUserRole(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteUserRole(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteUserRole = () => {
  return {
    type: A.REQUEST_DELETE_USER_ROLE,
  };
};

const receiveDeleteUserRole = (data) => {
  return {
    type: A.RECEIVE_DELETE_USER_ROLE,
    data,
  };
};

const errorDeleteUserRole = (err) => {
  return {
    type: A.ERROR_DELETE_USER_ROLE,
    err,
  };
};

export const fetchGetPaymentSettings = () => {
  let url = `${HOST}/api/lite/settings/checkout/payment`;
  return (dispatch, getState) => {
    dispatch(requestGetPaymentSettings());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetPaymentSettings(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetPaymentSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetPaymentSettings(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetPaymentSettings = () => {
  return {
    type: A.REQUEST_GET_PAYMENT_SETTINGS,
  };
};

const receiveGetPaymentSettings = (data) => {
  return {
    type: A.RECEIVE_GET_PAYMENT_SETTINGS,
    data,
  };
};

const errorGetPaymentSettings = (err) => {
  return {
    type: A.ERROR_GET_PAYMENT_SETTINGS,
    err,
  };
};

export const fetchGetProductsStockRevise = (warehouse_id) => async (dispatch, getState) => {
  let url = `${HOST}/api/lite/products/stock_revise`;
  if (warehouse_id) url += `?warehouse_id=${warehouse_id}`;

  return new Promise((resolve, reject) => {
    apiGet({
      url,
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          resolve(res);
        } else {
          const err = { data: { errors: res.errors } };
          reject(err);
        }
      },
      error: (err) => {
        reject(err);
      },
    });
  });
};

export const fetchGetNotifications = () => {
  let url = `${HOST}/api/lite/domain_notification`;
  return (dispatch, getState) => {
    dispatch(requestGetNotifications());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetNotifications(res.notifications));
            resolve(res.notifications);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetNotifications(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetNotifications(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetNotifications = () => {
  return {
    type: A.REQUEST_GET_NOTIFICATIONS,
  };
};

const receiveGetNotifications = (data) => {
  return {
    type: A.RECEIVE_GET_NOTIFICATIONS,
    data,
  };
};

const errorGetNotifications = (err) => {
  return {
    type: A.ERROR_GET_NOTIFICATIONS,
    err,
  };
};

export const fetchGetNotificationTypes = () => {
  let url = `${HOST}/api/lite/domain_notification/types`;
  return (dispatch, getState) => {
    dispatch(requestGetNotificationTypes());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetNotificationTypes(res.types));
            resolve(res.types);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetNotificationTypes(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetNotificationTypes(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetNotificationTypes = () => {
  return {
    type: A.REQUEST_GET_NOTIFICATION_TYPES,
  };
};

const receiveGetNotificationTypes = (data) => {
  return {
    type: A.RECEIVE_GET_NOTIFICATION_TYPES,
    data,
  };
};

const errorGetNotificationTypes = (err) => {
  return {
    type: A.ERROR_GET_NOTIFICATION_TYPES,
    err,
  };
};

export const fetchUpdateNotification = (data) => {
  let url = `${HOST}/api/lite/domain_notification`;
  return (dispatch, getState) => {
    dispatch(requestUpdateNotification());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateNotification(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateNotification(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateNotification(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateNotification = () => {
  return {
    type: A.REQUEST_UPDATE_NOTIFICATION,
  };
};

const receiveUpdateNotification = (data) => {
  return {
    type: A.RECEIVE_UPDATE_NOTIFICATION,
    data,
  };
};

const errorUpdateNotification = (err) => {
  return {
    type: A.ERROR_UPDATE_NOTIFICATION,
    err,
  };
};

export const fetchDeleteNotification = (notificationId) => {
  let url = `${HOST}/api/lite/domain_notification?id=${notificationId}`;
  return (dispatch, getState) => {
    dispatch(requestDeleteNotification());
    return new Promise((resolve, reject) => {
      apiDelete({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteNotification(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteNotification(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteNotification(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteNotification = () => {
  return {
    type: A.REQUEST_DELETE_NOTIFICATION,
  };
};

const receiveDeleteNotification = (data) => {
  return {
    type: A.RECEIVE_DELETE_NOTIFICATION,
    data,
  };
};

const errorDeleteNotification = (err) => {
  return {
    type: A.ERROR_DELETE_NOTIFICATION,
    err,
  };
};

export const fetchGetRegions = () => {
  let url = `${HOST}/api/lite/settings/regions`;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          resolve(res.regions);
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchGetPossibleAdresses = (fbmType) => {
  let url = `${HOST}/api/lite/orders/fbo/delivery/warehouses?fbmType=${fbmType}`;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchPostDeliveryRegionsSettings = (body) => {
  let url = `${HOST}/api/lite/settings/checkout/delivery-region-settings`;
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  };
};

export const fetchUpdateAdAttachments = (data) => {
  let url = `${HOST}/api/lite/settings/adAttachments`;
  return (dispatch, getState) => {
    dispatch(requestUpdateAdAttachments());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAdAttachments(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAdAttachments(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAdAttachments(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateAdAttachments = () => {
  return {
    type: A.REQUEST_UPDATE_AD_ATTACHMENTS,
  };
};

const receiveUpdateAdAttachments = (data) => {
  return {
    type: A.RECEIVE_UPDATE_AD_ATTACHMENTS,
    data,
  };
};

const errorUpdateAdAttachments = (err) => {
  return {
    type: A.ERROR_UPDATE_AD_ATTACHMENTS,
    err,
  };
};

export const fetchGetAdAttachments = () => {
  let url = `${HOST}/api/lite/settings/adAttachments`;
  return (dispatch, getState) => {
    dispatch(requestGetAdAttachments());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetAdAttachments(res.adAttachments));
            resolve(res.adAttachments);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetAdAttachments(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetAdAttachments(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetAdAttachments = () => {
  return {
    type: A.REQUEST_GET_AD_ATTACHMENTS,
  };
};

const receiveGetAdAttachments = (data) => {
  return {
    type: A.RECEIVE_GET_AD_ATTACHMENTS,
    data,
  };
};

const errorGetAdAttachments = (err) => {
  return {
    type: A.ERROR_GET_AD_ATTACHMENTS,
    err,
  };
};

export const fetchDeleteAdAttachment = (id) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteAdAttachment());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: HOST + '/api/lite/settings/adAttachments?id=' + id,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteAdAttachment(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteAdAttachment(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteAdAttachment(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteAdAttachment = () => {
  return {
    type: A.REQUEST_DELETE_AD_ATTACHMENTS,
  };
};

const receiveDeleteAdAttachment = (data) => {
  return {
    type: A.RECEIVE_DELETE_AD_ATTACHMENTS,
    data,
  };
};

const errorDeleteAdAttachment = (err) => {
  return {
    type: A.ERROR_DELETE_AD_ATTACHMENTS,
    err,
  };
};

export const fetchGetProviders = () => {
  let url = `${HOST}/api/lite/settings/service/providers?type=FULFILLMENT`;
  return (dispatch, getState) => {
    dispatch(requestGetProviders());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.providers) {
            dispatch(receiveGetProviders(res.providers));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetProviders(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetProviders(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetProviders = () => {
  return {
    type: A.REQUEST_GET_PROVIDERS,
  };
};

const receiveGetProviders = (data) => {
  return {
    type: A.RECEIVE_GET_PROVIDERS,
    data,
  };
};

const errorGetProviders = (err) => {
  return {
    type: A.ERROR_GET_PROVIDERS,
    err,
  };
};

/*Отправка заявки провайдеру*/

export const fetchPostProvider = (data) => {
  let url = `${HOST}/api/lite/service/providers/setup/claim`;
  return (dispatch, getState) => {
    dispatch(requestPostProvider());
    return new Promise((resolve, reject) => {
      apiPost({
        url,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostProvider(res));
            resolve(res);
            toast.info('Заявка успешно отправлена');
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostProvider(err));
            toast.error(`${err.data.errors[0].message}` || 'Неизвестная ошибка');
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostProvider(err));
          toast.error('Возникла ошибка: попробуйте обратиться в поддержку');
          reject(err);
        },
      });
    });
  };
};

const requestPostProvider = () => {
  return {
    type: A.REQUEST_POST_PROVIDER,
  };
};

const receivePostProvider = (data) => {
  return {
    type: A.RECEIVE_POST_PROVIDER,
    data,
  };
};

const errorPostProvider = (err) => {
  return {
    type: A.ERROR_POST_PROVIDER,
    err,
  };
};

/*
 * Источники заказов
 */

const requestGetEshopsInfo = () => {
  return {
    type: A.REQUEST_GET_ESHOPS_INFO,
  };
};

const receiveGetEshopsInfo = (data) => {
  return {
    type: A.RECEIVE_GET_ESHOPS_INFO,
    data,
  };
};

const errorGetEshopsInfo = (err) => {
  return {
    type: A.ERROR_GET_ESHOPS_INFO,
    err,
  };
};

export const fetchGetEshopsInfo = () => {
  let url = `${HOST}/api/lite/settings/eshop/info`;
  return (dispatch, getState) => {
    dispatch(requestGetEshopsInfo());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          dispatch(receiveGetEshopsInfo(res.eshops));
          resolve(res.eshops);
        },
        error: (err) => {
          dispatch(errorGetEshopsInfo(err));
          reject(err);
        },
      });
    });
  };
};

const errorUpdateEshopInfo = (err) => {
  return {
    type: A.ERROR_UPDATE_ESHOP_INFO,
    err,
  };
};

export const fetchUpdateEshopSettings = (eshop) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/settings/eshop/info`,
        tokens: getState().auth.tokenData,
        body: eshop,
        callback: (res) => {
          if (res.success) {
            resolve(res);
            toast.info('Успешное обновление');
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateEshopInfo(err));
            reject(err);
            toast.error(res.errors[0].message || 'Возникла ошибка, обратитесь в поддержку');
          }
        },
        error: (err) => {
          dispatch(errorUpdateEshopInfo(err));
          reject(err);
        },
      });
    });
  };
};
